export default __webpack_public_path__ + "static/media/cover-congrats@3x.0e70e055.png";